import {LobbyImage} from '@colonist/types'
import {
    type RulebookPage,
    RulebookStyle,
    getRulebookPagePathname,
    getRulebookStylePathname,
} from '../../../../shared/enums/RulebookEnums.ts'
import {createDivIn, createIFrameIn, createImgIn, setElementOnClick} from '../ui_utils/DomUtils.ts'
import {UIPopup} from './UIPopup.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {replaceLanguageInPath} from '../ClientI18n.ts'

export class UIPopupRulebook extends UIPopup {
    private defaultPage: RulebookPage
    private isRulebookPopupCreated: boolean = false

    constructor(page: RulebookPage) {
        super()
        this.defaultPage = page
    }

    setDefaultPage(page: RulebookPage) {
        this.defaultPage = page
    }

    show() {
        if(!this.isRulebookPopupCreated) this.createRulebookPopup()
        super.show()
    }

    private createRulebookPopup() {
        const src = UIPopupRulebook.getRulebookPageSrc(this.defaultPage)
        const contentContainer = createDivIn(this.container, 'popup-rulebook')

        createIFrameIn(contentContainer, '100%', '100%', src)

        const closeButton = createDivIn(contentContainer, 'close-button')
        const closeButtonImg = createImgIn(closeButton, LobbyImage.XMark)
        setElementOnClick(closeButton, () => this.hide())

        this.setEscapeKeyBind()
        this.isRulebookPopupCreated = true
    }

    private static getRulebookPageSrc(page: RulebookPage): string {
        const pathPrefix = UIUtilsEjsVariables.isUserOnDiscord ? '/.proxy' : ''
        const style = UIUtilsEjsVariables.isUserOnDiscord ? RulebookStyle.Discord : RulebookStyle.Popup
        const pathname = `${pathPrefix}/catan-rules${getRulebookPagePathname(page)}${getRulebookStylePathname(style)}`
        const url = new URL(replaceLanguageInPath(pathname, UIUtilsEjsVariables.language), location.origin)
        url.search = location.search

        return url.href
    }
}
